// extracted by mini-css-extract-plugin
export default {"schedule":"schedule___VHbkt","activityTimeCard":"activityTimeCard___mCxOy","dot":"dot___LCQGZ","text":"text___zVbFd"};